import { useEffect, useRef, useCallback } from "react";
import { initializePaddle, type Paddle } from "@paddle/paddle-js";
import { INVITATION_PRICING_PLANS_ENUM } from "../store/services/invitations/dto/invitations.dto";

interface CheckoutRefs {
	invitationId: string;
	userId: string;
	planId: number;
	oldPlanId: number;
	email: string;
}

/**
 * Initializes Paddle.js once on mount, returns a function to open checkout.
 * Use inside the component where the "Buy" button lives.
 */
export function usePaddleCheckout() {
	const paddleRef = useRef<Paddle | undefined>(undefined);

	useEffect(() => {
		initializePaddle({
			environment: (process.env.REACT_APP_PADDLE_ENV as "sandbox" | "production") ?? "sandbox",
			token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN!
		}).then(paddleInstance => {
			paddleRef.current = paddleInstance;
		});
	}, []);

	const openCheckout = useCallback((refs: CheckoutRefs, priceId: string) => {
		if (!paddleRef.current) {
			console.error("Paddle not yet initialized");
			return;
		}
		console.log(refs);

		paddleRef.current.Checkout.open({
			items: [{ priceId: priceId, quantity: 1 }],
			customer: { email: refs.email },
			customData: {
				invitationId: refs.invitationId,
				planId: refs.planId,
				userId: refs.userId
			},
			settings: {
				displayMode: "overlay",
				theme: "light",
				showAddTaxId: false,
				allowLogout: false,
				successUrl: `${window.location.origin}/paddlePaymentCallback/invitation/${refs.invitationId}`
			}
		});
	}, []);

	return { openCheckout };
}
